export default __webpack_public_path__ + "static/myway-logo-big~DIoniLNd-5ace1adf8c3522adb08e0821c9f50d0d.png";